import ProgressBar from "../shared/progressbar/progressbar";
import ProgressBarInfo from "./progressBarInfo/progressBarInfo";
import { ProgressBarFieldProps } from "./types/progressBarFieldProps"

const ProgressBarField = (props: ProgressBarFieldProps) => {

    return (
        <div style={props.style}>
            <ProgressBarInfo {...props.progressBarInfoProps}/>
            <ProgressBar {...props.progressBarProps}/>
        </div>
    )
}

export default ProgressBarField;